import { useDraggable } from '@dnd-kit/core';
import { TaskRow } from './TaskRow.js';
import { useIsMobile } from '../hooks/useIsMobile.js';
import type { Task } from '../api/tasks.js';
import { cn } from '../lib/cn.js';

export function BoardTaskRow({ task }: { task: Task }): React.ReactElement {
  const isMobile = useIsMobile();
  if (isMobile) return <TaskRow task={task} hideProject compact />;
  return <DraggableBoardTaskRow task={task} />;
}

function DraggableBoardTaskRow({ task }: { task: Task }): React.ReactElement {
  // Pendant le geste, la ligne reste en place, estompée : c'est le `DragOverlay` de `Board` qui
  // voyage, hors de la colonne qui la rognerait.
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id: task.taskId });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      // La colonne défile (`overflow-y-auto`), donc rogne tout ce qui dépasse en largeur : l'anneau
      // de focus du kit, posé 2 px à l'extérieur, perdait ses côtés. Il passe à l'intérieur ici,
      // pour la ligne comme pour ce qu'elle contient.
      className={cn(
        'touch-none [--focus-ecart:calc(-1*var(--focus-epaisseur))]',
        isDragging && 'opacity-50 pointer-events-none'
      )}
    >
      <TaskRow task={task} hideProject compact />
    </div>
  );
}
